import TriggerCard from 'pages/AutomationEngine/Engine/Steps/TriggerCard';
import { capitalize } from 'components/helpers';
import DraggableStepCard from 'pages/AutomationEngine/Engine/Steps/DraggableStepCard';
import { getValueOrDeleted } from '../action/action-helpers';

export const content = ({ step }) => step.description;

export const getDescription = ({ step, t }) => {
  return `Tag '${getValueOrDeleted(
    step.details.tagId?.label,
    t
  )}' is ${capitalize(step.details.tagOperation)}`;
};

export default function Card({ step, ...others }) {
  return step?.goalType ? (
    <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>
  ) : (
    <TriggerCard {...others}>{content({ step })}</TriggerCard>
  );
}
